var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"spinner-border",attrs:{"aria-hidden":"true"}}),_c('p',[_vm._v("Carregando...")])])}]

export { render, staticRenderFns }